<template >
  <div id="app"  :class="appClass">



    <router-view/>
    </div>

</template>
<script>
export default {
  name: 'App',
  computed: {
    appClass () {
      return {
        results: this.$route.path.indexOf('/results') > -1
      }
    }
  }
}
</script>

<style lang="scss">
	html {
		box-sizing: border-box;
	}

	*, *:before, *:after {
		box-sizing: inherit;
	}

	h1, h2 {
		margin-top: 0;
		text-transform: uppercase;
		color: #2B2F32;
	}

	h1, h2 {
		font-size: 1.2rem;
	}

	h3{
		font-size:1.1rem;
	}

	.group:after {
		content: "";
		display: table;
		clear: both;
	}

	body {
		background-color: #00384e;
		font-family: 'Montserrat', sans-serif;
		overflow-x:hidden;
	}

	html, body {
		height: 100%;
	}

	a {
		color: #38B7EA;
		text-decoration: none;
	}

		a:hover {
			text-decoration: underline;
		}

	#app {
		max-width: 2000px;
		margin: 0 auto;
		background-color: #F5F8F9;
		min-height: 100%;
		border-left: 1px solid #ececec;
		border-right: 1px solid #ececec;

		&.results{
			@media only screen and (min-width: 800px) {
				height:100%;
				min-height: 700px;
			}
		}
	}

	.header-icon {
		a{
			color: #3D4043;
		}

		p {
			margin: 5px 0 0 0;
		}

		svg {
			color: #525252;
			width: 40px !important;
			height: 40px !important;
			vertical-align: -.125em !important;
		}

	}

	.no-style-list {
		padding-left: 0px;
		list-style: none;
	}

	.fake-anchor {
		color: #38B7EA;
		background: none;
		border: 0;
	}

	.fake-anchor:hover {
		text-decoration: underline;
	}

	.fl-l {
		float: left;
	}

	.fl-r {
		float: right;
	}

	.flex{
		display:flex;
	}

	.visuallyhidden {
		border: 0;
		clip: rect(0 0 0 0);
		height: 1px;
		margin: -1px;
		overflow: hidden;
		padding: 0;
		position: absolute;
		width: 1px;
	}
	.visuallyhidden.focusable:active,
	.visuallyhidden.focusable:focus {
		clip: auto;
		height: auto;
		margin: 0;
		overflow: visible;
		position: static;
	}

	.basic-table{
		th{
			text-align:left;
		}

		th,td{
			vertical-align:top;
		}
	}

	.multiselect__tags{
		min-height:36px !important;
		border: 1px solid #e4e4e4 !important;
		border-radius:0 !important;
	}

	.multiselect.single {
		.multiselect__single{
			color: #000 !important;
		}
	}

	.multiselect.multiple{
		.multiselect__single{
			color: #afafaf !important;
		}
	}

	.multiselect__tag, .multiselect__option--highlight, .multiselect__option--highlight::after{
		background:#38b7ea !important;
	}

	.multiselect__tag-icon:hover{
		background:#2a90b9 !important;
	}

	.multiselect__input{
		padding-left:0 !important;
		margin-left:0 !important;
	}

	.multiselect__single{
		padding-left:0 !important;
		margin-left:0 !important;
	}

	.fa-spinner{
		width:30px !important;
		height:30px !important;

		margin-top:0;
		-webkit-animation:spin 0.7s linear infinite;
		-moz-animation:spin 0.7s linear infinite;
		animation:spin 0.7s linear infinite;
	}
	@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
	@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
	@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
</style>
